import * as yaml from "js-yaml";
import useTextStore from "../state/TextStore";

export async function initializeTextData() {
  try {
    const basepath: string = process.env.REACT_APP_PATH || "";

    const filePath = `${basepath}/text/local-text.yml`;
    const response = await fetch(filePath);
    const content = await response.text();

    const parsedYaml = loadAndFlattenYaml(content);

    if (parsedYaml) {
      useTextStore.setState({ texts: parsedYaml });
    } else {
      console.error(
        "Error loading texts from file:",
        "No valid YAML data found.",
      );
    }
  } catch (error) {
    console.error("Error initializing text data:", error);
  }
}

function loadAndFlattenYaml(yamlText: string) {
  const parsedYaml = yaml.load(yamlText) as Record<string, string>;
  return flatten(parsedYaml);
}

function flatten(
  record: Record<string, string> | string,
  parentKey = "",
): Record<string, string> {
  if (typeof record === "string") {
    return { [parentKey]: record };
  }

  return Object.keys(record).reduce<Record<string, string>>(
    (accumulator, key) => {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      if (typeof record[key] === "object" && !Array.isArray(record[key])) {
        const nested = flatten(record[key], fullKey);
        Object.assign(accumulator, nested);
      } else {
        accumulator[fullKey] = record[key];
      }
      return accumulator;
    },
    {},
  );
}
